import CustomSpin from 'elements/CustomSpin'
import React, { Component } from 'react'
import BigCalendar from 'react-big-calendar'
import moment from 'moment'
import { DndProvider } from 'react-dnd'
import { HTML5Backend } from 'react-dnd-html5-backend'

import { message } from 'antd'

import 'react-big-calendar/lib/css/react-big-calendar.css'
import 'react-big-calendar/lib/addons/dragAndDrop/styles.less'

import withDragAndDrop from 'react-big-calendar/lib/addons/dragAndDrop'
import Events from '../../../api/Events'
import omitEmpty from 'omit-empty'
import { omit } from 'lodash'

BigCalendar.momentLocalizer(moment)
let allViews = Object.keys(BigCalendar.Views).map((k) => BigCalendar.Views[k])
const DragAndDropCalendar = withDragAndDrop(BigCalendar)
const localizer = BigCalendar.momentLocalizer(moment) // or globalizeLocalizer

class CalendarView extends Component {
  api = new Events()

  moveEvent = async ({ event, start, end }) => {
    let updatedEvent = { ...event }
    updatedEvent.start = {
      date: moment(start).format('YYYY-MM-DD'),
      dateTime: moment(start).format(),
      milliseconds: moment(start).unix(),
    }
    updatedEvent.end = {
      date: moment(end).format('YYYY-MM-DD'),
      dateTime: moment(end).format(),
      milliseconds: moment(end).unix(),
    }

    updatedEvent = omit(updatedEvent, ['title', 'desc', 'dateRange'])
    updatedEvent = omitEmpty(updatedEvent)
    try {
      this.setState({ loading: true })
      await this.api.update(updatedEvent)
      message.success('Updated!')
      this.props.handleCancel(true)
    } catch (error) {
      this.setState({ loading: false })
      message.error(error.errorMessage)
    }
  }

  render() {
    let { events, handleSelectEvent, handleSelect, calendars, fetching } = this.props
    events = events.map((e) =>
      Object.assign({}, e, {
        title: e.name,
        allDay: e.allDay,
        start: new Date(e.start.dateTime),
        end: new Date(e.end.dateTime),
        desc: e.description,
      })
    )
    return (
      <CustomSpin spinning={fetching}>
        <div style={{ height: '720px', backgroundColor: '#fff' }}>
          <DndProvider backend={HTML5Backend}>
            <DragAndDropCalendar
              events={events}
              localizer={localizer}
              selectable
              onSelectSlot={handleSelect}
              views={allViews}
              onEventDrop={this.moveEvent}
              defaultDate={new Date()}
              onSelectEvent={handleSelectEvent}
              eventPropGetter={(event, start, end, isSelected) => {
                return {
                  style: {
                    backgroundColor: calendars.find((c) => c._id === event.calendar._id).color,
                  },
                }
              }}
            />
          </DndProvider>
        </div>
      </CustomSpin>
    )
  }
}

export default CalendarView
